<h1 mat-dialog-title>Check Out Device</h1>
<div mat-dialog-content>
  <form #basicForm="ngForm">
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Device UUID</label>
          </div>
          <div class="control-cont">
            <input type="text" name="uuid" [(ngModel)]="model.uuid" class="mer-text-field" disabled />
          </div>
        </div>
      </div>
    </div>
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Checking Out</label>
          </div>
          <div class="control-cont">
            <input type="text" name="checkedoutfor" [(ngModel)]="model.checkedoutfor" class="mer-text-field" required />
          </div>
        </div>
      </div>
      <div class="flex-sep"></div>
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Reason</label>
          </div>
          <div class="control-cont">
            <input type="text" name="reason" [(ngModel)]="model.reason" class="mer-text-field" required />

          </div>
        </div>
      </div>
    </div>
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Check Out Date</label>
          </div>
          <div class="control-cont">

            <div class="display-flex flex-items-centered merlin-date position-relative">
              <div class="flex-grow-1">
                <input matInput [matDatepicker]="checkoutDatePicker" class="mer-date-picker" name="checkoutDate" [(ngModel)]="model.checkoutDate" placeholder="dd/mm/yyyy">
              </div>
              <div class="position-absolute to-right">
                <mat-datepicker-toggle matSuffix [for]="checkoutDatePicker">
                  <img class="date-picker-img" src="/assets/images/dateIcon.svg" matDatepickerToggleIcon />
                </mat-datepicker-toggle>
              </div>
              <div>
                <mat-datepicker #checkoutDatePicker></mat-datepicker>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="flex-sep"></div>
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Check In Date</label>
          </div>
          <div class="control-cont">

            <div class="display-flex flex-items-centered merlin-date position-relative">
              <div class="flex-grow-1">
                <input matInput [matDatepicker]="checkinDatePicker" class="mer-date-picker" name="checkinDate" [(ngModel)]="model.checkinDate" placeholder="dd/mm/yyyy">
              </div>
              <div class="position-absolute to-right">
                <mat-datepicker-toggle matSuffix [for]="checkinDatePicker">
                  <img class="date-picker-img" src="/assets/images/dateIcon.svg" matDatepickerToggleIcon />
                </mat-datepicker-toggle>
              </div>
              <div>
                <mat-datepicker #checkinDatePicker></mat-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Approved By</label>
          </div>
          <div class="control-cont">
            <input type="text" name="approvedby" [(ngModel)]="model.approvedby" class="mer-text-field" required />
          </div>
        </div>
      </div>
      <div class="flex-sep"></div>
      <div class="flex-grow-1">
        <div class="merlin-control">
          
        </div>
      </div>
    </div>
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Notes</label>
          </div>
          <div class="control-cont">
            <textarea rows="2" class="mer-text-field mer-textarea" name="notes" [(ngModel)]="model.notes">
        </textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions class="display-flex">
  <div class="flex-grow-1"></div>
  <button class="main-btn empty-back-btn margin-m" [mat-dialog-close]="false">CANCEL</button>
  <button class="main-btn filled-back-btn" (click)="checkout()" cdkFocusInitial [disabled]="basicForm.invalid">CHECK OUT</button>
</div>
